import {
  type CarePathwayEvaluationChangeStageRequestDtoType,
  type CarePathwayEvaluationRequestDtoType,
  type CarePathwayEvaluationResponseDtoType,
  type NextPatientDtoType,
  type NextPatientMetadataDtoType,
  type TransitionNextPatientRequestDtoType,
} from '@tempus/trials-types';

import { Physician } from '../types/patientTrackerStore';
import axios from '../axios';
import { TRIALS_NEST_API_ROOT } from '../constants';

export const nextPatientApi = {
  getMetadata: async (nextPatientCarePathwayId: string): Promise<NextPatientMetadataDtoType> => {
    return axios
      .get(`${TRIALS_NEST_API_ROOT}/next-patient/care-pathway/${nextPatientCarePathwayId}/metadata`)
      .then(({ data }) => data);
  },
  getSitePhysicians: async (nextPatientCarePathwayId: string): Promise<Physician[]> => {
    return axios
      .get(`${TRIALS_NEST_API_ROOT}/next-patient/care-pathway/${nextPatientCarePathwayId}/site-physicians`)
      .then(({ data }) => data);
  },
  transition: async (body: TransitionNextPatientRequestDtoType): Promise<NextPatientDtoType> => {
    return axios.post(`${TRIALS_NEST_API_ROOT}/next-patient/transition`, body).then(({ data }) => data);
  },
};

export const nextPatientCarePathwayApi = {
  get: async (nextPatientCarePathwayId: string): Promise<CarePathwayEvaluationResponseDtoType> => {
    return axios
      .get(`${TRIALS_NEST_API_ROOT}/next-patient-care-pathway/${nextPatientCarePathwayId}`)
      .then(({ data }) => data);
  },
  screen: async (
    nextPatientCarePathwayId: string,
    body: CarePathwayEvaluationRequestDtoType,
  ): Promise<CarePathwayEvaluationResponseDtoType> => {
    return axios
      .post(`${TRIALS_NEST_API_ROOT}/next-patient-care-pathway/${nextPatientCarePathwayId}/screen`, body)
      .then(({ data }) => data);
  },
  changeStage: (
    nextPatientCarePathwayId: string,
    body: CarePathwayEvaluationChangeStageRequestDtoType,
  ): Promise<CarePathwayEvaluationResponseDtoType> => {
    return axios
      .post(`${TRIALS_NEST_API_ROOT}/next-patient-care-pathway/${nextPatientCarePathwayId}/change-stage`, body)
      .then(({ data }) => data);
  },
};
